module.exports = __webpack_public_path__ + "img/business-guide.63db3df4.svg";